export default __webpack_public_path__ + "static/media/bg-group-bobike.395e5997.png";